import { jsx as _jsx } from "react/jsx-runtime";
import ivclass from 'clsx';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import { useEffect, useRef } from 'react';
function TemplateListLoader({ size, loadMoreTemplates, }) {
    const loadMoreRef = useRef(null);
    const entry = useIntersectionObserver(loadMoreRef, {});
    const isVisible = !!entry?.isIntersecting;
    useEffect(() => {
        if (isVisible) {
            entry && loadMoreTemplates?.();
        }
    }, [isVisible]);
    return (_jsx("div", { ref: loadMoreRef, className: ivclass(`templateTrayLoaderIVShared`, size, 'iv-rounded-template-card iv-mb-[24px]') }));
}
export default TemplateListLoader;
